import { endpoints, host } from '@config/endpoints';
import request from './request';

export interface TSignUpParams {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    googleId: string;
}

export async function signUp(data: TSignUpParams) {
    const { path, method } = endpoints.users.registerGoogle;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            data,
            {},
        ));
    } catch (error) {
        // @ts-ignore
        if (error && error.response && error.response.data && error.response.data.message)
        {
            // @ts-ignore
            err = error.response.data.message;
        } else {
            // @ts-ignore
            err = error.message;
        }
    }

    return [err, res];
}
